import { render, staticRenderFns } from "./MainTabContent.vue?vue&type=template&id=11679548"
import script from "./MainTabContent.vue?vue&type=script&lang=js"
export * from "./MainTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports